// Components
import { StepMediaVideoIntegrationsComponent } from './step-media-video-integrations.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_MEDIA_VIDEO_INTEGRATIONS = {
  stepIdentifier: 'mediaUploadFlowStepVideoIntegrations',
  identifier: 'uploadVideoIntegrations',
  component: StepMediaVideoIntegrationsComponent,
  name: 'Integrations',
  title: 'Select your integrations',
  subtitle: 'Upload your signed media to your connected services',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
} as MediaUploadFlowStep;
